import { DisplayElementModel } from './display-element.model';
import { DividerStyleModel } from './divider-style.model';

export class DividerDisplayElementModel extends DisplayElementModel {
    declare styles: DividerStyleModel;

    constructor(
        styles?: any
    ) {
        super();
        this.styles = new DividerStyleModel(styles);
        this.isBoundToGlobalStyles = true;
    }

    canRender(): boolean {
        return true;
    }

    clone(): DividerDisplayElementModel {
        const clone = new DividerDisplayElementModel(JSON.parse(JSON.stringify(this.styles)));
        clone.displayType = this.displayType;

        return clone;
    }

    onUpdate(): boolean {
        return false;
    }

    isEqual(other: DividerDisplayElementModel): boolean {
        if (!other) {
            return false;
        }
        if (!this.styles.equals(other.styles)) {
            return false;
        }
        if (this.isBoundToGlobalStyles !== other.isBoundToGlobalStyles) {
            return false;
        }
        return true;
    }
}
